import { render, staticRenderFns } from "./posSeach.vue?vue&type=template&id=abb317c6&scoped=true&"
import script from "./posSeach.vue?vue&type=script&lang=js&"
export * from "./posSeach.vue?vue&type=script&lang=js&"
import style0 from "./posSeach.vue?vue&type=style&index=0&id=abb317c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb317c6",
  null
  
)

export default component.exports